import React from "react"

import classes from "@/components/SearchInlineIconWrapper/SearchInlineIconWrapper.module.css"

export const SearchInlineIconWrapper = ({ children }) => <div className={classes.wrapper}>{children}</div>
